<div class="mainSectionwithNav d-flex pos_relative" id="bucket-items-list-cnt-shell" (click)="searchComponent.closePanel()">
  <div class="main-container" id="bucket-items-list-cnt-root">
    <div class="fixed-header">
      <div class="header-section header-margin-container" id="bucket-items-list-cnt-header">
        <span class="d-flex w-40" id="bucket-items-list-cnt-title-row">
          <a class="icon-ic-back mr-20" id="bucket-items-list-btn-back" (click)="goBack()"></a>
          <app-section-title class="max-w-55" id="bucket-items-list-lbl-title" title="{{ getBucketDisplayName(title) }}"></app-section-title>
          <div class="p-l-s" id="bucket-items-list-cnt-total">
            <span class="count-icon font-l" id="bucket-items-list-tag-total">{{ getDisplayCountText() }}</span>
          </div>
        </span>
        <div class="action-list d-flex" id="bucket-items-list-cnt-actions" [class.noExportAudit]="true">
          @if (displayRename) {
            <div class="action-box">
              <button
                class="action-button flexCenterAlign"
                id="bucket-items-list-btn-rename"
                (click)="renameFolderPopUp()"
                >
                <span class="icon-ic-rename color-link"></span>
                <div class="action-name">Rename</div>
              </button>
              <div class="divider"></div>
            </div>
          }

          @if (displayDownload) {
            <div class="action-box">
              <button
                class="action-button flexCenterAlign"
                id="bucket-items-list-btn-download"
                (click)="downloadBucketItem()"
                >
                <span class="icon-ic-download color-link"></span>
                <div class="action-name">
                  Download
                </div>
              </button>
              @if (displayFolderPermission || displayTransfer || displayMove || displayTags || displayDelete) {
                <div
                class="divider"></div>
              }
            </div>
          }

          @if (displayFolderPermission && !multiSelection) {
            <div class="action-box">
              <button
                class="action-button flexCenterAlign"
                id="bucket-items-list-btn-share"
                (click)="loadDynamicComponent('Folder Permission')"
                >
                <span class="icon-ic-share-folder color-link"></span>
                <div class="action-name">
                  Share
                </div>
              </button>
              @if (!multiSelection) {
                <div class="divider"></div>
              }
            </div>
          }

          @if (displayTransfer) {
            <div class="action-box">
              <button
                class="action-button flexCenterAlign"
                id="bucket-items-list-btn-transfer"
                (click)="loadDynamicComponent('Transfer Package')"
                >
                <span class="icon-ic-transfer color-link"></span>
                <div class="action-name">
                  Transfer
                </div>
              </button>
              @if (!multiSelection) {
                <div class="divider"></div>
              }
            </div>
          }

          @if (displayMove) {
            <div class="action-box">
              <button
                class="action-button flexCenterAlign"
                id="bucket-items-list-btn-move"
                (click)="openMoveItems()"
                >
                <span class="icon-ic-move color-link"></span>
                <div class="action-name">Move</div>
              </button>
              @if (displayTags || displayDelete) {
                <div class="divider"></div>
              }
            </div>
          }

          @if (displayDelete) {
            <div class="action-box">
              <button
                class="action-button flexCenterAlign"
                id="bucket-items-list-btn-delete"
                (click)="CheckForEmptyFolder()"
                >
                <span class="icon-ic-delete color-link"></span>
                <div class="action-name">
                  Delete
                </div>
              </button>
              @if (displayExportAuditTrail || displayTags) {
                <div class="divider"></div>
              }
            </div>
          }

          @if (displayExportAuditTrail) {
            <div class="action-box">
              <button
                class="action-button flexCenterAlign"
                id="bucket-items-list-btn-export-audit"
                (click)="exportAuditTrailButton()"
                >
                <span class="icon-ic-export color-link"></span>
                <div class="action-name">
                  Export Audit Trail
                </div>
              </button>
              @if (displayExportContent) {
                <div class="divider"></div>
              }
            </div>
          }

          @if (displayExportContent) {
            <div class="action-box">
              <button
                class="action-button flexCenterAlign"
                id="bucket-items-list-btn-export-content"
                (click)="exportContentList()"
                >
                <span class="icon-ic-export color-link"></span>
                <div class="action-name">
                  Export Content List
                </div>
              </button>
            </div>
          }

          @if (displayTags) {
            <div class="action-box">
              <button
                class="action-button flexCenterAlign"
                id="bucket-items-list-btn-tags"
                (click)="handleGlobalTagsAction()"
                >
                <span class="icon-ic-tags color-link"></span>
                <div class="action-name">
                  Tags
                </div>
              </button>
            </div>
          }

          <div class="action-box p-left">
            <span
              class="icon-ic-Search color-link pointCursor"
              id="bucket-items-list-btn-search"
              matTooltip="Search"
              matTooltipClass="tooltip-style"
              (click)="openSearch()"
            ></span>
            <div
              class="action-name pointCursor"
              id="bucket-items-list-btn-clear-search"
              (click)="onClearSearch($event)"
              >
              Clear Search
            </div>
          </div>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div id="bucket-items-list-cnt-search-host">
      <app-search
        #searchComponent
        class="disp_none"
        id="bucket-items-list-cmp-search"
        [bucketListInput]="bucketList()"
        [contextBucketType]="currentBreadcrumbItem?.BucketType"
        [contextBuCode]="currentBreadcrumbItem?.BUCode"
        (searchData)="onSearch($event)"
        (searchToggle)="searchExpandedFlag($event)"
        >
      </app-search>
    </div>
    <mat-divider></mat-divider>
    @if (searchResults?.BucketItems?.length === 0 && IsSearched) {
      <div class="empty_grid_container" id="bucket-items-list-cnt-empty-search">
        <p>No data matching your search criteria</p>
        <app-no-document-found class="icon-layout"></app-no-document-found>
      </div>
    }
    <div class="mainPanel" id="bucket-items-list-cnt-main-panel">
      @if (!(searchResults?.BucketItems?.length === 0 && IsSearched)) {
        <div class="leftPanel" id="bucket-items-list-cnt-left-panel">
        <div id="bucket-items-list-cnt-table" class="tableContainer" [ngClass]="{
          'height-bucketItems-1':
            !isSearchable,
          'height-bucketItems-2':
            isSearchable && !searchExpand,
          'height-bucketItems-3':
            isSearchable && searchExpand
        }">
          <div id="bucket-items-list-cnt-virtual-scroll" [ngClass]="{
              'virtual-view-port-1':
                !isSearchable,
              'virtual-view-port-2':
                isSearchable && !searchExpand,
              'virtual-view-port-3':
                isSearchable && searchExpand 
            }" class="templateTableVirtualScroll enableScroll w-100"
              appLazyScroll
              [threshold]="60"
              [isLoading]="pendingOperations.size > 0"
              [resetTrigger]="searchResetCounter"
              [hasMorePages]="hasMorePages"
              (nearEnd)="handleLazyLoad()">
              @if (bucketItems) {
                <table aria-describedby="Bucket Items Display" #table mat-table matSort (matSortChange)="onSortChange($event)"
                  id="bucket-items-list-tbl-grid" [dataSource]="bucketItems"
                  class="table-height input-min-spacing table-flex">
                  @if (!(IsSearched && !isOnlyPackageFolders)) {
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef class="w-63">
                        @if (showGlobalCheckbox) {
                          <mat-checkbox
                            class="example-margin"
                            id="bucket-items-list-chk-select-all"
                            [checked]="allItemsChecked"
                            [indeterminate]="someChecked()"
                            (change)="setAll($event.checked)"
                            >
                          </mat-checkbox>
                        }
                      </th>
                      <td mat-cell *matCellDef="let item" class="w-63">
                        <mat-checkbox
                          [ngModel]="item.IsChecked"
                          id="bucket-items-list-chk-row-{{ item.Id }}"
                          [checked]="item.IsChecked"
                          (click)="$event.stopPropagation(); onRowCheckboxClick(item)"
                          >
                        </mat-checkbox>
                      </td>
                    </ng-container>
                  }
                  <ng-container matColumnDef="ItemType">
                    <th mat-header-cell *matHeaderCellDef class="w-63"></th>
                    <td mat-cell *matCellDef="let item" class="w-63">
                  <img class="icon-layout" [src]="
                      item.Type === 'Folder'
                        ? 'assets/images/bucket-icons/icon-folder.svg'
                        : 'assets/images/bucket-icons/icon-file.svg'
                    " alt="Folder" />
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="Name">
                      <th mat-sort-header mat-header-cell class="name-column" *matHeaderCellDef resizeColumn>
                        Name
                      </th>
                      <td mat-cell class="name-column" *matCellDef="let item">
                        <!-- Normal view (non-search OR only-package-folder search) -->
                        @if (!(IsSearched && !isOnlyPackageFolders)) {
                          <div class="d-flex">
                            @if (item.Type === 'Folder') {
                              <div class="text-overflow-ellipsis color-link"
                                matTooltipClass="tooltip-style"
                                matTooltipPosition="above"
                                appMatTooltip="{{item.LeafName}}"
                                [attr.id]="buildListControlId('folder-name-wrapper', item.Id)">
                                <span>
                                  <a id="bucket-items-list-btn-folder-{{ item.Id }}"
                                    (click)="navigateToFolder(item)">
                                    {{ item.LeafName }}
                                  </a>
                                </span>
                                @if ((item.JustificationRequiredCount ?? 0) > 0) {
                                  <div>
                                    <a class="justification-link"
                                      [attr.id]="buildListControlId('justification-required-link', item.Id)"
                                      (click)="$event.stopPropagation(); navigateToPendingJustifications(item)">
                                      Justification Required: {{ item.JustificationRequiredCount }}
                                    </a>
                                  </div>
                                }
                              </div>
                            }
                            @if (item.IsLocked) {
                              <span
                                class="icon-ic-lock primary-color p-l-xs"
                                id="bucket-items-list-btn-lock-{{ item.Id }}"
                                (click)="showInformation($event, item, true)">
                              </span>
                            }
                          </div>
                        }
                        <!-- File -->
                        @if (item.Type === 'File') {
                          <div class="flex-column">
                            <span class="text-overflow-ellipsis"
                              matTooltipClass="tooltip-style"
                              matTooltipPosition="above"
                              appMatTooltip="{{item.LeafName}}"
                              [attr.id]="buildListControlId('file-name', item.Id)">
                              {{ item.LeafName }}
                            </span>
                            <div class="align-self-start">
                              <span class="tag versionTag">{{ item.UIVersion }}</span>
                              @if (item.IsMalicious) {
                                <span class="p-l-s">
                                  <span class="maliciousTag">Malicious File</span>
                                </span>
                              }
                            </div>
                          </div>
                        }
                        <!-- Search grid (mixed results only) -->
                        @if (item.Type === 'Folder' && (IsSearched && !isOnlyPackageFolders)) {
                          <div class="flex-column"
                            >
                            <div class="text-overflow-ellipsis">
                              <span class="folder-name"
                                matTooltipClass="tooltip-style"
                                matTooltipPosition="above"
                                [matTooltip]="item.LeafName">
                                {{ item.LeafName }}
                              </span>
                            </div>
                          </div>
                        }
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="Tags">
                      <th mat-header-cell *matHeaderCellDef resizeColumn [minWidth]="100">Tags</th>
                      <td mat-cell class="tags-column" *matCellDef="let item">
                        @if (item.TagsWithValues?.length > 0) {
                          <div class="flex-column">
                            <div class="align-self-start">
                              <span class="tag versionTag chip-version">
                                {{ item.TagsWithValues[0].TagValue }}
                              </span>
                            </div>
                            @if (item.TagsWithValues.length > 1) {
                              <div class="moreTags"
                                id="bucket-items-list-btn-more-tags-{{ item.Id }}"
                      (click)="
                        $event.stopPropagation();
                        openMoreTagsOverlay($event, item.TagsWithValues)
                      "
                                >
                                +{{ item.TagsWithValues.length - 1 }} more
                              </div>
                            }
                          </div>
                        }
                      </td>
                    </ng-container>
                    @if (IsSearched && !isOnlyPackageFolders) {
                      <ng-container matColumnDef="Path">
                        <th mat-header-cell *matHeaderCellDef class="mw-vw-17" resizeColumn [minWidth]="150">
                          <span>Path</span>
                        </th>
                        <td mat-cell *matCellDef="let block" class="mw-vw-17 path-cell">
                          <span class="link-wrapper mt-10">
                            <a class="contentPath">
                              <div class="ellipsisLeft"
                                [ellipsisText]="block.DirName"
                                appMatTooltip="{{block.DirName}}"
                                matTooltipClass="tooltip-style"
                                matTooltipPosition="above"
                                (click)="navigateToSearchResultFolder($event,block)"
                                (keydown.enter)="navigateToSearchResultFolder($event,block)">
                                <span>{{ block.DirName }}</span>
                              </div>
                            </a>
                          </span>
                        </td>
                      </ng-container>
                    }
                    <ng-container matColumnDef="Created By">
                      <th mat-sort-header mat-header-cell *matHeaderCellDef resizeColumn [width]="50" [minWidth]="50">
                      Uploaded By</th>
                      <td mat-cell *matCellDef="let item">
                        <span
                          id="bucket-items-list-btn-uploader-{{ item.Id }}"
                          (click)="showInformation($event, item, false)"
                          [ngClass]="{'text-puid': (item !== null && item.FullName && item.EmailId)}"
                          [class.autocursor]="!(item?.FullName && item?.EmailId)">
                          {{ item.CreatedBy }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="Created On">
                      <th mat-sort-header mat-header-cell *matHeaderCellDef resizeColumn [width]="150" [minWidth]="150">
                      Uploaded On</th>
                      <td mat-cell *matCellDef="let item">
                        {{ item.CreatedOn | date : "dd MMM yyyy, HH:mm" }} (UTC) <br />
                        {{ item.CreatedOn + "Z" | date : "dd MMM yyyy, HH:mm" }} (Local Time)<br />
                      </td>
                    </ng-container>
                    @if (!(IsSearched && !isOnlyPackageFolders)) {
                      <ng-container matColumnDef="icon-column">
                        <th mat-header-cell *matHeaderCellDef class="w-60 sticky-right-column"></th>
                        <td mat-cell *matCellDef="let item" class="w-60 sticky-right-column">
                          <div class="horizontal-display">
                            @if (item.ChecksumStatus === 'VerifiedAndCorrupted') {
                              <button class="mat-tbl-icon" mat-icon-button
                                [attr.id]="buildListControlId('checksum-warning-button', item.Id)">
                                <span class="icon-ic-warning color-error cursor" matTooltip="{{ checksum_fail_tooltip }}"
                                  matTooltipClass="tooltip-style"
                                  [attr.id]="buildListControlId('checksum-warning-icon', item.Id)">
                                </span>
                              </button>
                            }
                            @if (item.Id === hoverindex) {
                              <button
                                rippleOnHover
                                class="mat-tbl-icon"
                                id="bucket-items-list-btn-row-menu-{{ item.Id }}"
                      mat-icon-button (click)="
                        $event.stopPropagation();
                        onMoreClick(
                          $event,
                          item.Id,
                          item.IsChecked,
                          item.LeafName,
                          item.Type,
                          currentBreadcrumbItem.BucketType,
                          item.FolderType
                        )
                      ">
                                <span class="icon-ic_more" matTooltip="More" matTooltipClass="tooltip-style"
                                [attr.id]="buildListControlId('row-menu-icon', item.Id)"></span>
                              </button>
                            }
                          </div>
                        </td>
                      </ng-container>
                    }
                    @if (IsSearched && !isOnlyPackageFolders) {
                      <ng-container matColumnDef="Download">
                        <th mat-header-cell *matHeaderCellDef class="w-60 sticky-right-column"></th>
                        <td mat-cell *matCellDef="let item" class="w-60 sticky-right-column">
                          <div class="horizontal-display">
                            <button rippleOnHover class="mat-tbl-icon" mat-icon-button
                              [matTooltip]="'Download'" matTooltipClass="tooltip-style"
                              (click)="$event.stopPropagation(); downloadBucketItem(item)">
                              <span class="icon-ic-download color-link"></span>
                            </button>
                          </div>
                        </td>
                      </ng-container>
                    }
                    <tr mat-header-row
                      *matHeaderRowDef="(IsSearched && !isOnlyPackageFolders) ? searchColumnList : columnList; sticky: true">
                    </tr>
                    <tr mat-row
                      class="emptyCss"
    [ngClass]="{
      highlightRow:
        row.StudyCompletionDate === null &&
        row.IsConsideredForTransfer &&
        row.IsChecked,

      highlightRowSearch:
        highlightRow !== '' && row.Id === highlightRow,

      clickedRow: clickedRow === row.Id,

      maliciousFile: row.IsMalicious
    }"
                      *matRowDef="let row; columns: (IsSearched && !isOnlyPackageFolders) ? searchColumnList : columnList; let i = index"
                      (mouseover)="!(IsSearched && !isOnlyPackageFolders) && rowMouseOver(row)"
                      (click)="IsSearched ? onRowClick(row) : clickedRowData(row)"
                      (keydown.enter)="IsSearched ? onRowClick(row) : clickedRowData(row)"
    (contextmenu)="
      !(IsSearched && !isOnlyPackageFolders) && $event.stopPropagation();
      !(IsSearched && !isOnlyPackageFolders) && onMoreClick(
        $event,
        row.Id,
        row.IsChecked,
        row.LeafName,
        row.Type,
        currentBreadcrumbItem.BucketType,
        row.FolderType
      )
    ">
                    </tr>
                  </table>
                }
                <!-- Inline spinner for lazy-load appends (search and browse) -->
                @if (pendingOperations.size > 0 && hasMorePages && ((IsSearched && pageNumber > 1) || (!IsSearched && browsePageNumber > 1))) {
                  <div
                    class="lazy-load-spinner-row">
                    <mat-spinner diameter="30"></mat-spinner>
                    <span class="lazy-load-label">Loading more…</span>
                  </div>
                }
                @if (bucketItems.length === 0) {
                  <div class="empty_grid_container" id="bucket-items-list-cnt-empty-items">
                    <p>No folders to be displayed</p>
                    <app-no-document-found class="icon-layout"></app-no-document-found>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <div
          class="rightPanel"
          id="bucket-items-list-cnt-right-panel"
          [hidden]="searchResults?.BucketItems?.length === 0 && IsSearched"
        [ngClass]="{
        'rightPanel-height-1':
          !isSearchable,
        'rightPanel-height-2':
          isSearchable && !searchExpand,
        'rightPanel-height-3':
          isSearchable && searchExpand
      }">
          <!-- Dynamic template -->
          <div class="dynamic-template" id="bucket-items-list-cnt-dynamic-slot">
            <ng-template #dynamic></ng-template>
          </div>
        </div>
        <!--Fixed right panel containing all icons-->
        @if (!(searchResults?.BucketItems?.length === 0 && IsSearched)) {
          <div class="fixedSideNav" id="bucket-items-list-cnt-side-nav">
            <button
              [class.isActive]="isActive === 'General Information'"
              rippleOnHover
              mat-icon-button
              class="mat-tbl-icon m-b-s rel-pos"
              [matTooltip]="'General information'"
              matTooltipClass="tooltip-style"
              id="bucket-items-list-btn-general-info"
              (click)="loadDynamicComponent('General Information')"
              >
              <span class="icon-ic-general-info"></span>
            </button>
            <button
              [class.isActive]="isActive === 'FileFolder Upload'"
              rippleOnHover
              mat-icon-button
              class="mat-tbl-icon m-b-s rel-pos"
              [matTooltip]="isPackageLevel() ? 'Upload Folder' : 'Upload Files/Folder'"
              matTooltipClass="tooltip-style"
              id="bucket-items-list-btn-upload"
         (click)="openUploadDragAndDrop()" *appHasDisplayIcons="
            currentBreadcrumbItem?.BucketType;
            type: 'Upload'
          "
              >
              <span class="icon-ic-upload" ></span>
            </button>
            @if (!displayCreateFolderInPreArchive) {
              <span>
                <button
                  [class.isActive]="isActive === 'Create Folder'"
                  rippleOnHover
                  mat-icon-button
                  class="mat-tbl-icon m-b-s"
                  [matTooltip]="'Create folder'"
                  matTooltipClass="tooltip-style"
                  id="bucket-items-list-btn-create-folder"
            (click)="loadDynamicComponent('Create Folder')" *appHasDisplayIcons="
              currentBreadcrumbItem?.BucketType;
              type: 'Create Folder'
            "
                  >
                  <span class="icon-ic-new-folder"></span>
                </button>
              </span>
            }
            <button
              [class.isActive]="isActive === 'Version History'"
              rippleOnHover
              mat-icon-button
              class="mat-tbl-icon m-b-s"
              [matTooltip]="'Version history'"
              matTooltipClass="tooltip-style"
              id="bucket-items-list-btn-version-history"
          (click)="loadDynamicComponent('Version History')" *appHasDisplayIcons="
            currentBreadcrumbItem?.BucketType;
            type: 'Version History'
          "
              >
              <span class="icon-ic-history"></span>
            </button>
            <button
              [class.isActive]="isActive === 'Folder Templates'"
              rippleOnHover
              mat-icon-button
              class="mat-tbl-icon m-b-s"
              [matTooltip]="'Folder Templates'"
              matTooltipClass="tooltip-style"
              id="bucket-items-list-btn-folder-templates"
          (click)="loadDynamicComponent('Folder Templates')" *appHasDisplayIcons="
            currentBreadcrumbItem?.BucketType;
            type: 'Folder Templates'
          "
              >
              <span class="icon-ic-add"></span>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
